export const SECURITY_FEATURE_STRINGS = {
  canResidentsUseIt: 'Can your residents use it?',
  howOperatePlaceholder: 'Brief description of how to operate',
  yes: 'Yes',
  no: 'No',
  inputPlaceholder: 'Brief description of how to operate',
  doesHaveAnythingOfTheFollowing:
    'Does the security system have any of the following?',
};
